// Runtime env helper - supports build-time injected vars (Vite/Vue CLI)
// and a window.__env object that can be generated at app-start via config.js.
//
// window.__env is expected to be a plain object, e.g.:
//   window.__env = { VUE_APP_FUNCTIONS_KEY: '...', VUE_APP_FUNCTIONS_BASE: '...' };
// config.js should be placed in /public and can be overwritten at runtime by
// the App Service start-up script.

export function getEnv(name) {
  // 1. build-time Vite style
  if (typeof import.meta !== 'undefined' && import.meta.env && name in import.meta.env) {
    return import.meta.env[name];
  }

  // 2. build-time Vue CLI style  
  if (process.env && name in process.env) {
  // if (typeof process !== 'undefined' && process.env && name in process.env) {
    // console.log("GET ENV -process.env", process.env)
    // console.log("GET ENV ", name,  process.env[name])  process.env.NODE_ENV
    return process.env[name];
  }

  // 3. runtime injection via window.__env
  if (typeof window !== 'undefined' && window.__env && name in window.__env) {
    return window.__env[name];
  }

  return '';
}

